import {useQueries} from "@tanstack/react-query";
import natureService from "../../../../services/web/nature-service.js";
import acceptanceRulesService from "../../../../services/web/acceptance-rules-service.js";

const UseFetchData = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['reasons'],
                queryFn: () => natureService.optionsName().then(data => {
                    const options = data.map(({id, text}) => ({value: id, label: text}));
                    options.unshift({value: "*", label: "Todas naturezas"})

                    return options
                })
            },
            {
                queryKey: ['city'],
                queryFn: () => acceptanceRulesService.interconnectedCities().then(data => {
                    const options = data.map(({id, text}) => ({value: id, label: text}));
                    options.unshift({value: "*", label: "Todos municípios"})

                    return options
                })
            }
        ]
    });

    return {
        reasons: queries[0].data ?? [],
        city: queries[1].data ?? [],
    }
};

export default UseFetchData;